/**
 * Checks whether the url passed
 * or current url host is whitelist
 * @param url - optional url to pass
 */
const isWhitelistHost = (url) => {
    const urlString = url || window.location.href;
    const whitelistCheck = /(\.|^)(syf|synchrony|mysynchrony|synchronycredit|carecredit|synchronymastercard|syfbank|synchronytravel|synchronytravel\.membershipdev).com$/;
    try {
        const urlObject = new URL(urlString);
        return whitelistCheck.test(urlObject.host);
    }
    catch (error) {
        return false;
    }
};
export default isWhitelistHost;
